module.exports = __webpack_public_path__ + "static/media/apropos_img_ar.a0c0cca1.png";